module.exports = __webpack_public_path__ + "assets/img/dzh-37.07093a54.jpg";